<template>
  <div class="base-accordion">
    <div role="tablist">
      <button
        :id="'accordion-btn-' + randomId"
        :aria-controls="'accordion-panel-' + randomId"
        class="base-accordion__toggle font-s"
        role="tab"
        :aria-selected="isExpanded"
        :aria-expanded="isExpanded"
        @click="onToggleClick"
      >
        {{ label }} <i class="base-accordion__icon icon-Up" aria-hidden="true"></i>
      </button>
    </div>
    <div
      :id="'accordion-panel-' + randomId"
      ref="panel"
      :aria-labelledby="'accordion-btn-' + randomId"
      class="base-accordion__panel"
      role="tabpanel"
      :aria-hidden="!isExpanded"
      :style="{
        '--base-accordion-height': contentHeight ? `${contentHeight}px` : null,
      }"
    >
      <div ref="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue';
import useId from '../../../composables/useId';

const props = defineProps({
  label: String,
  initialState: {
    type: String,
    default: 'closed',
    validator: (value) => {
      return ['open', 'closed'].includes(value);
    },
  },
});

const TRANSITION = 200;

const randomId = useId();

const isExpanded = ref(true);

const panel = ref(null);
const content = ref(null);
const contentHeight = ref(null);

const onToggleClick = () => {
  contentHeight.value = content.value.offsetHeight;
  setTimeout(() => (isExpanded.value = !isExpanded.value), 0);
  setTimeout(() => (contentHeight.value = null), TRANSITION);
};

onBeforeMount(() => {
  isExpanded.value = props.initialState === 'open';
});
</script>

<style lang="scss">
@import './scss/BaseAccordion.scss';
</style>
